import {createReducer} from '../utils';
import {default as types} from '../constants';

const initialState = {
    model: {
        name: '',
        street: '',
        post_code: '',
        city: '',
        nip: '',
        phone: '',
        old_password: '',
        new_password: ''
    },
    production_overlap: ''
};

export default createReducer(initialState, {
    [types.RECEIVE_CUSTOMER]: (state, payload) => {
        return Object.assign({}, state, {
            'model': payload.model
        });
    },
    [types.RECEIVE_PRODUCTION_OVERLAP]: (state, payload) => {
        return Object.assign({}, state, {
            'production_overlap': payload.production_overlap
        });
    }    
});


/** WEBPACK FOOTER **
 ** ./js/reducers/customer.js
 **/